import useDeviceType from "@/hooks/useDeviceType";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "reactfire";
import getImageProcessData from "../../components/AccountDetails/ImageProccessData/handlers/getImageProcessData";
import CardForNewUser from "./CardForNewUser";

const DownloadMessageMobile = () => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const { isMobileOrTablet } = useDeviceType();

  const userData = queryClient.getQueryData(["user"]) as any;
  const referralCode = userData?.data?.referral?.code;

  const { data: imageProcessData, isLoading: imageProcessDataLoading } =
    useQuery({
      queryKey: ["image-process-data", referralCode ?? ""],
      queryFn: () => getImageProcessData(referralCode ?? ""),
      enabled: !!referralCode,
    });

  const commonContent = (
    <div className="flex flex-col items-center justify-between space-y-4 rounded-lg bg-white p-6 text-center text-4xl shadow-xl">
      <div className="px-10 font-erode-variable font-light tracking-[-0.3] text-nightRider">
        Download Aftershoot App
      </div>
      <div className="text-xs text-nightRider">
        Go to{" "}
        <a
          href="https://aftershoot.com/downloads"
          target="_blank"
          rel="noopener"
          className="text-cornflowerBlue"
        >
          www.aftershoot.com/downloads
        </a>{" "}
        from your desktop device to download the app
      </div>
    </div>
  );

  const renderMobileContent = () => {
    if (imageProcessDataLoading && !!referralCode) {
      return <div className="p-6 text-center">Loading...</div>;
    }

    const albumsProcessed = imageProcessData?.data?.albums ?? 0;
    const shouldShowNewlySignedUpCard = albumsProcessed < 1;

    if (shouldShowNewlySignedUpCard && auth.currentUser) {
      return <CardForNewUser />;
    }
    return commonContent;
  };

  if (!isMobileOrTablet) return null;

  return <div>{renderMobileContent()}</div>;
};

export default DownloadMessageMobile;
